module.exports = __webpack_public_path__ + "img/fuhe1.8b0cfee8.png";